/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import AggregataSelector from '../../common/AggregataSelector';
import ExpandedViewToggle from '../../common/ExpandedViewToggle';
import { GROUPED_VIEW_MARKETS } from '../../data/constants';
import BetGeniusWidget from '../../data/widgets/BetGeniusWidget';
import FlashbetWidget from '../../data/widgets/FlashbetWidget';
import StatsCoreWidget from '../../data/widgets/StatsCoreWidget';
import { bgWidgetEnabled, brWidgetS5Enabled, getBetgeniustWidgetUrl, getFlashbetWidgetUrl, statsCoreWidgetEnabled, STATSCORE_WIDGET_LIVESCORE, WidgetContext } from '../../data/widgets/WidgetContext';
import Streaming from '../Streaming';
import PartialScoresNavbar from './PartialScoresNavbar';
import BetradarWidget from '../../data/widgets/BetradarWidget';
import { StreamingContext } from '../Live';
import { getMatchStreamingProps, getStreamingId } from '../../data/streaming/streamingUtils';
import { getConfiguration } from '../../data/utils/configuration';

function LiveMatchNavbar(props) {
    const conf = getConfiguration();
    const widgetContext = React.useContext(WidgetContext);
    const streamingContext = React.useContext(StreamingContext);
    const match = props.match;
    const isBrWidgetS5 = brWidgetS5Enabled(match.sportRef,match.widgetType);
    const isBetgeniusWidget = bgWidgetEnabled(match.sportRef,match.widgetType,match.geniusId);
    const isStatsCoreWidget = statsCoreWidgetEnabled(STATSCORE_WIDGET_LIVESCORE, widgetContext.widgetProviderType,match.lsportWidgetId);
    const flashbetWidgetUrl = getFlashbetWidgetUrl(match.widgetType);
    const streamingMap = getMatchStreamingProps(props.match);
    const streaming = streamingMap && streamingMap[props.match.id];
    const streamingId = getStreamingId(streaming);

    const gruppiScommessa = props?.gruppiScommessa.sort((a, b) => {
        if (a.idAggregata < 0) {
            return -1;
        }
        if (b.idAggregata < 0) {
            return 1;
        }
        return a.ranking - b.ranking;
    });

    function toggleStreaming() {
        if (isStreamingOpened()) {
            closeStreaming();
        } else {
            streamingContext.toggleStreamingId(streaming,streamingId, match.id);
        }
    }

    function isStreamingOpened() {
        return streamingContext.streamingId === streamingId;
    }

    function closeStreaming() {
        streamingContext.toggleStreamingId(null,null,null);
    }

    useEffect(() => {
        if (props.stickyWidget) {
            const container = document.getElementById('cg_exa-sportAppContainer');
            if (container != null) {
                container.onscroll = () => {
                    if (container.scrollTop > 200) {
                        document.querySelector('.xs-widget-container')?.classList.add('scale-widget');
                    } else {
                        document.querySelector('.xs-widget-container')?.classList.remove('scale-widget');
                    }
                };
                return () => {
                    container.onscroll = null;
                };
            } else {
                window.onscroll = () => {
                    if (window.pageYOffset > 200) {
                        document.querySelector('.xs-widget-container')?.classList.add('scale-widget');
                    } else {
                        document.querySelector('.xs-widget-container')?.classList.remove('scale-widget');
                    }
                };
                return () => {
                    window.onscroll = null;
                };
            }
        }
    }, []);

    useEffect(() => {
     
        if(conf.lstwc && streamingContext.streamingId == null){
            streamingContext.toggleStreamingId(streaming,streamingId, match.id)
        }
    }, [match.id]);

    let groupedView = false;
    if (match.bets.length === 1 && GROUPED_VIEW_MARKETS.includes(match.bets[0].cs)) {
        groupedView = true;
    }

    return (
        <>
            <div className={`xs-widget-container ${isStatsCoreWidget?'xs-widget-container-statscore':''}`}>
                {
                    flashbetWidgetUrl ?
                        <div id="br_widget" className="overlay-container-flashbet-widget">
                            {widgetContext.widgetContainerId === '#br_widget' && 
                                <FlashbetWidget url={flashbetWidgetUrl}/>
                            }
                            <Streaming />
                            <div id="stats-container"></div>
                        </div>
                    :
                    isBetgeniusWidget?
                    <>
                        {widgetContext.widgetContainerId === '#br_widget' && 
                            <BetGeniusWidget url={getBetgeniustWidgetUrl(props.match.sportRef, props.match.categoryRef, props.match.tournamentRef)} />
                        }
                        <Streaming />
                        <div id="stats-container"></div>
                    </>
                    :
                    isStatsCoreWidget?
                    <>
                        {widgetContext.widgetContainerId === '#br_widget' && 
                            <StatsCoreWidget />
                        }
                    </>
                    :
                    <>
                        {widgetContext.widgetContainerId === '#br_widget' && 
                            <BetradarWidget id="br_widget" className={`betradar-widget sr-widget sr-widget-level-0 sr-widgets-lmts sr-size-small sr480 ${isBrWidgetS5 ? 'brWidgetS5' : ''}`} data-sr-lang="it" data-sr-handle="16" 
                                            matchId={match.id} 
                                            streamingComponent={<Streaming/>}
                                            streaming={streaming} toggleStreaming={toggleStreaming} />
                        }
                        {!conf.lstwc &&  <Streaming />}
                        <div id="stats-container"></div>
                    </>
                }
            </div>
            {props.match.score.formattedScores.length > 1 &&
                <PartialScoresNavbar scores={props.match.score.formattedScores} />
            }
            {props.giocabilita &&
                <AggregataSelector betGroups={gruppiScommessa} aggregata={props.aggregata} changeBetGroup={props.changeAggregata} />
            }
            {groupedView &&
                <nav id="nav-vista-estesa" className="small">
                    <ExpandedViewToggle />
                </nav>
            }
        </>
    );
}

export default LiveMatchNavbar;